import WebviewMessenger from './WebviewMessenger';

export async function copyText(text) {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }
    const field = document.createElement('textarea');
    field.value = text;
    field.readOnly = true;
    field.style.cssText = 'position:fixed;top:0;left:-9999px;';
    const active = document.activeElement;
    document.body.appendChild(field);
    try {
        field.select();
        field.setSelectionRange(0, field.value.length);
        if (!document.execCommand?.('copy')) throw new Error('Copy unavailable');
    } finally {
        field.remove();
        active?.focus?.({ preventScroll: true });
    }
}

export async function shareText(text) {
    if (WebviewMessenger.isInWebView()) {
        WebviewMessenger.send({ type: 'SHARE', text });
        return 'requested'; // Opening a share sheet is not delivery confirmation.
    }
    if (navigator.share) {
        try { await navigator.share({ text }); return 'shared'; }
        catch (error) { if (error.name === 'AbortError') return 'cancelled'; throw error; }
    }
    await copyText(text);
    return 'copied';
}
